import { useCallback } from 'react'

interface JwtPayload {
  realm_access?: { roles: string[] }
  sub?: string
  [key: string]: unknown
}

export const useJwt = () => {
  const getDecodedPayload = useCallback((jwt: string): JwtPayload => {
    const base64url = jwt.split('.')[1]
    if (!base64url) {
      throw new Error('Invalid JWT: missing payload segment')
    }
    let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/')
    const padding = base64.length % 4

    if (padding) {
      base64 += '='.repeat(4 - padding)
    }

    return JSON.parse(window.atob(base64)) as JwtPayload
  }, [])

  return { getDecodedPayload }
}
